import { ReactNode } from 'react';
import { useRouter } from 'next/router';
import { Wrapper } from './TopNavigation.styled';
import { Subtitle, IconChevronLeft } from '@/components/atoms';

interface IProps {
  children: ReactNode;
  hasPrevIcon?: boolean;
}

const TopNavigation = (props: IProps) => {
  const { children, hasPrevIcon } = props;
  const router = useRouter();

  const handleClickPrevIcon = () => {
    router.back();
  };

  return (
    <Wrapper>
      {hasPrevIcon && <IconChevronLeft width={20} color="gray-800" onClick={handleClickPrevIcon} />}
      <Subtitle level={2} color="gray-800">
        {children}
      </Subtitle>
    </Wrapper>
  );
};

export default TopNavigation;
